module.exports = __webpack_public_path__ + "static/img/bwjt.65bfda4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bwjt.png
// module id = 8b46
// module chunks = 44